import React, { useState } from "react";
import { Button, message } from "antd";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";

// components
import SKIP_TOPIC from "graphql/mutations/SkipTopic";
import SkipTopicModal from "./SkipTopicModal";

// graphql

interface SkipTopicButtonProps {
  targetTopicId: number;
  skippedSuccessFn: () => void;
}

const SkipTopicButton = ({
  targetTopicId,
  skippedSuccessFn,
}: SkipTopicButtonProps) => {
  const { t } = useTranslation("class_details");

  // STATES
  const [isSkipTopicModalVisible, setSkipTopicModalVisible] = useState(false);

  // HANDLERS
  const handleOpenSkipTopicModal = () => setSkipTopicModalVisible(true);
  const handleCloseSkipTopicModal = () => setSkipTopicModalVisible(false);

  const [skipTopic] = useMutation(SKIP_TOPIC, {
    refetchQueries: [], // TODO: add GetClassDetails query
    onCompleted: () => {
      handleCloseSkipTopicModal();
      skippedSuccessFn();
      message.success(t("Your topic was skipped!"));
    },
    onError: () => {
      handleCloseSkipTopicModal();
      message.error(t("Cannot skip this topic."));
    },
  });

  const handleConfirmSkipTopic = () => {
    skipTopic({
      variables: {
        id: targetTopicId,
      },
    });
  };

  return (
    <>
      <Button
        className="section-button size-2 skip-button"
        name="skipTopic"
        type="primary"
        onClick={() => handleOpenSkipTopicModal()}
      >
        {t("SKIP THIS TOPIC")}
      </Button>
      <SkipTopicModal
        visible={isSkipTopicModalVisible}
        onConfirm={handleConfirmSkipTopic}
        onCancel={handleCloseSkipTopicModal}
      />
    </>
  );
};

export default SkipTopicButton;
